import React from "react";

export interface StepVisualizerProps {
    steps: string[];
    currentStep: number
}

export const StepVisualizer = (props: StepVisualizerProps) => {
    const stepState = (step: number): string => {
        if (step === props.currentStep)
            return "active";

        if (step < props.currentStep)
            return "done";

        return null;
    }

    const renderSteps = () => {
        const listItems = [];
        for (var i = 1; i <= props.steps.length; i++) {
            let state = stepState(i);
            listItems.push(
                <li className={state} key={i}>
                    <span className="badge">{i}</span>
                    <span className="step-header">{props.steps[i - 1]}</span>
                </li>
            );
        }

        return listItems;
    };

    return (
        <ul className="steps">
            {renderSteps()}
        </ul>
    );
}